<div class="container-fluid">

	<div class="row align-items-center">
        <div class="col-10 py-2">
            <h1 class="my-3">Inventario {{store.name }} - {{stocktake.created | shortDate:'full'}}</h1>
        </div>
        <div class="col-2 d-print-none text-end">
            <button type="button" class="btn btn-secondary m-1" (click)="export()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m2.859 2.878l12.57-1.796a.5.5 0 0 1 .571.495v20.847a.5.5 0 0 1-.57.495L2.858 21.123a1 1 0 0 1-.859-.99V3.868a1 1 0 0 1 .859-.99ZM17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4V3Zm-6.8 9L13 8h-2.4L9 10.286L7.4 8H5l2.8 4L5 16h2.4L9 13.714L10.6 16H13l-2.8-4Z"/></svg>
            </button>
        </div>
    </div>	

	<div class="card my-3">
		<div class="row mb-3 py-3 mx-0">
			<div class="col-4 fw-bold border-bottom">Articulos registrados</div>
			<div class="col-8 text-end text-md-start border-bottom">{{cresume.item_count | number}}</div>
			<div class="col-8 col-md-4 fw-bold border-bottom">Articulos Inventariados</div>
			<div class="col-4 col-md-2 text-end text-md-start border-bottom">{{cresume.stocktake_item_count | number}}</div>

			<div class="col-8 col-md-2 fw-bold border-bottom">Total Sistema</div>
			<div class="col-4 col-md-1 text-end text-md-start border-bottom">{{cresume.db_qty_sum | number}}</div>

			<div class="col-8 col-md-2 fw-bold border-bottom">Total inventario</div>
			<div class="col-4 col-md-1 text-end border-bottom">{{cresume.real_qty_sum | number}}</div>
			<div class="col-8 col-md-4  fw-bold border-bottom">Articulos con Sobrante</div>
			<div class="col-4 col-md-2  text-end text-md-start border-bottom">{{cresume.surplus_item_count | number}}</div>
			<div class="col-8 col-md-4  fw-bold border-bottom">Total Sobrantes</div>
			<div class="col-4 col-md-2  text-end border-bottom">{{cresume.surplus_qty | number}}</div>
			<div class="col-8 col-md-4  fw-bold border-bottom">Articulos con faltantes</div>
			<div class="col-4 col-md-2  text-end text-md-start border-bottom">{{cresume.missing_item_count | number}}</div>
			<div class="col-8 col-md-4  fw-bold border-bottom">Total faltantes</div>
			<div class="col-4 col-md-2  text-end border-bottom">{{cresume.missing_qty | number}}</div>
			<div class="col-8 col-md-4  fw-bold border-bottom">Articulos con inventario correcto</div>
			<div class="col-4 col-md-2  text-end text-md-start border-bottom">{{ cresume.ok_item_count | number}}</div>
			<div class="col-8 col-md-4  fw-bold border-bottom">Total inventario correcto</div>
			<div class="col-4 col-md-2  text-end border-bottom">{{cresume.ok_item_sum | number}}</div>
		</div>
		<!-- div class="row">
			<div class="col-6" *ngIf="selected_stocktake">
				<button type="button" class="btn btn-primary w-100" *ngIf="'ACTIVE' == selected_stocktake.status" (click)="applyStockDifferences()">Aplicar diferencias</button>
			</div>
			<div class="col-6" *ngIf="selected_stocktake">
				<button type="button" class="btn btn-primary w-100" *ngIf="'ACTIVE' == selected_stocktake.status" (click)="adjustStockValues()">Ajustar Inventarios</button>
			</div>
			<div class="col-12">
				<button type="button" class="btn btn-primary w-100 mt-3" (click)="show_resume=false">Cerrar</button>
			</div>
		</div -->
	</div>

	<div>
		<app-pagination [path]="path" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
	</div>

	<div class="card">
		<div class="d-none d-md-flex row border-bottom fw-bold mx-0">
			<div class="col-3">Artículo</div>
			<div class="col-3">Usuario</div>
			<div class="col-6 px-0">
				<div class="row mx-0">
					<div class="col-4 text-end">Cant. Sistema</div>
					<div class="col-2 text-end">Cant. Inventariado</div>
					<div class="col-2 text-end">Diferencia</div>
					<div class="col-2 text-end">Fecha</div>
				</div>
			</div>
		</div>
		<div *ngFor="let sti of stocktake_item_info_list" class="row border-bottom mx-0 blast">
			<div class="col-2 col-md-3 blast fw-bold">
				{{(sti.category && rest.local_preferences.display_categories_on_items == 'YES') ? sti.category.name+'-' : ''}}
				{{sti.item.name}}
			</div>
			<div class="col-12 col-md-3 blast">
				{{sti.user.name}}
			</div>
			<div class="col-12 col-md-6 px-0">
				<div class="row mx-0">
					<div class="col-12 col-md-4 text-md-end blast">{{sti.stocktake_item.db_qty | number}}</div>
					<div class="col-12 col-md-2 text-md-end blast">{{sti.stocktake_item.real_qty | number}}</div>
					<div class="col-12 col-md-2 text-md-end blast">{{sti.stocktake_item.real_qty - sti.stocktake_item.db_qty  | number}}</div>
					<div class="col-12 col-md-4 text-md-end">{{sti.stocktake_item.updated | shortDate:'full'}}</div>
				</div>
			</div>
		</div>
	</div>
	<div>
		<app-pagination [path]="path" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
	</div>
</div>
